import { cva, type VariantProps } from 'class-variance-authority'
import React, { ElementType, HTMLAttributes, forwardRef } from 'react'
import { cn } from './cn'

export const surfaceVariants = cva('rounded-lg border border-solid', {
  variants: {
    variant: {
      default: 'border-hairline bg-surface',
      raised: 'border-hairline bg-surface-2',
      outline: 'border-hairline bg-transparent',
      ghost: 'border-transparent bg-transparent',
    },
    padding: {
      none: 'p-0',
      sm: 'p-3',
      md: 'p-4',
      lg: 'p-6',
    },
    interactive: {
      true: 'cursor-pointer transition-colors duration-150 hover:bg-surface-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus',
    },
  },
  defaultVariants: { variant: 'default', padding: 'md' },
})

export interface SurfaceProps
  extends HTMLAttributes<HTMLElement>,
    VariantProps<typeof surfaceVariants> {
  as?: ElementType
}

/** Cards and panels: radius lg, hairline border. */
export const Surface = forwardRef<HTMLElement, SurfaceProps>(
  ({ as: Comp = 'div', variant, padding, interactive, className, ...props }, ref) => (
    <Comp
      ref={ref}
      className={cn(surfaceVariants({ variant, padding, interactive }), className)}
      {...props}
    />
  )
)
Surface.displayName = 'Surface'
